import { CardBlockReason } from '../../../../_interfaces/cards.interface';
import { CardBlockSelectOption } from '../../../interfaces/project-interfaces';

export const cardBlockSelectOptions: CardBlockSelectOption[] = [
  {
    label: 'Suspected Fraud',
    checked: false,
    value: CardBlockReason.Fraud,
  },
  {
    label: 'Card has been lost',
    checked: false,
    value: CardBlockReason.Lost,
  },
  {
    label: 'Card has been stolen',
    checked: false,
    value: CardBlockReason.Stolen,
  },
  {
    label: 'Other',
    checked: false,
    value: CardBlockReason.Other,
  },
];
